import { Button, Table, Tooltip } from "antd";
import React, { useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import SvgIcon from "../const/SvgIcon";

function RecentScheme() {
  const users_list = useSelector((state) =>
    state?.allapi?.category_list ? state?.allapi?.category_list : {}
  );
  const [page, setPage] = useState(1);
  const listdata = users_list?.docs ? users_list?.docs?.slice(0, 4) : [];

  const navigate = useNavigate();
  const columns = [
    {
      title: "S.No.",
      dataIndex: "sno",
      key: "sno",
      className: "table_first_col",
      render: (value, item, index) => (page - 1) * 10 + index + 1,
    },
    // {
    //   title: "Image",
    //   dataIndex: "image",
    //   key: "image",
    //   className: "table_action_col",
    //   render: (value, item, index) => {
    //     return (
    //       <>
    //         <div style={{ width: "100px" }}>
    //           <img style={{ width: "100%" }} src={URL?.API_BASE_URL + item?.image} alt="" />
    //         </div>
    //       </>
    //     );
    //   },
    // },
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
    },
    {
      title: "Area( Bigha)",
      dataIndex: "areaBigha",
      key: "areaBigha",
    },
    {
      title: "Loaction",
      dataIndex: "loaction",
      key: "loaction",
    },
    {
      title: "Scheme Register date",
      dataIndex: "RegDate",
      key: "RegDate",
    },
    // {
    //   title: "Email",
    //   dataIndex: "email",
    //   key: "email",
    // },

    // {
    //   title: "Status",
    //   dataIndex: "status",
    //   key: "status",
    //   className: "table_action_col",
    //   render: (value, item, index) => {
    //     return (
    //       <>
    //         <Tooltip title={item?.status}>
    //           <button
    //             className={
    //               item?.is_status == "Active"
    //                 ? "success-button ml-3"
    //                 : "delete-button ml-3"
    //             }
    //             onClick={() =>
    //               hendleToStatus(
    //                 item?._id,
    //                 item?.is_status == "Active" ? "Inactive" : "Active"
    //               )
    //             }
    //           >
    //             {item?.is_status}
    //           </button>
    //         </Tooltip>
    //       </>
    //     );
    //   },
    // },
    {
      title: "Actions",
      dataIndex: "action",
      key: "action",
      className: "table_action_col",
      render: (value, item, index) => {
        return (
          <>
            {/* <Tooltip title="Edit">
                  <span
                    className="cursor-pointer"
                    onClick={() => {
                      showModal(item);
                    }}
                  >
                    <SvgIcon.Edit className="scale-icon edit-icon" />
                  </span>
                </Tooltip> */}
            {/* <Tooltip title="Delete">
                  <span
                    className="cursor-pointer"
                    onClick={() => {
                                    hendleModalShow(item?.id)
                                  }}
                  >
                    <SvgIcon.deletebtn className="scale-icon edit-icon" />
                  </span>
                </Tooltip> */}
            <Tooltip title="View">
              <span
                className="cursor-pointer"
                onClick={() => {
                  navigate("/SchemeDetails/" + item?._id);
                }}
              >
                <SvgIcon.Visibility className="scale-icon edit-icon" />
              </span>
            </Tooltip>
            {/* <Tooltip title="Delete">
                  <span
                    className="cursor-pointer"
                    onClick={() => {
                      showDeleteConfirm(item?._id);
                    }}
                  >
                    <SvgIcon.deletebtn className="scale-icon edit-icon" />
                  </span>
                </Tooltip> */}
          </>
        );
      },
    },
  ];
  return (
    <div>
      <div className="flex gap10 mt-30">
        <div className="col-6">
          <div className="opacity-8 fw-bold fs-16">Recent Scheme</div>
        </div>
        <div className=" col-6 text-right">
          <div className="flex1 flex justify-content-end align-items-center">
            <Tooltip title="  View All">
              <Button
                type="primary"
                className="jop_btn"
                onClick={() => navigate("/category")}
              >
                View All
              </Button>
            </Tooltip>
          </div>
        </div>
      </div>
      <div className="tableResponsive mt-10">
        <Table
          dataSource={listdata}
          columns={columns}
          className={"table antd_table"}
          pagination={{
            current: page,
            pageSize: 10,
            onChange(current, pageSize) {
              //   hendlePahegi(current);
            },
            hideOnSinglePage: true,
            total: 4 ? 4 : 0,
          }}
        />
      </div>
    </div>
  );
}

export default RecentScheme;
